import React from 'react';
import { Body, Col, FlexRow, Box } from '@edreamsodigeo/prisma-design-system';
import { useTranslation } from '@edreamsodigeo/frontend-core';
import {
  SegmentDetails,
  CarrierLogo,
} from '@/components/ItineraryDetails/ItineraryDetailsUtils';
import { PriceFreezeDate } from '@/components/PriceFreezeDateTime/PriceFreezeDateTime';

function SegmentHeader({ text, carrier, departureDate }) {
  return (
    <FlexRow
      alignItems="center"
      justifyContent="space-between"
      aria-label="segmentHeader"
      mb="base"
    >
      <Col>
        <FlexRow alignItems="center" justifyContent="space-between">
          <Box pr="2x_small" sx={{ minWidth: '29px' }} aria-label={`${text}`}>
            <CarrierLogo carrierId={carrier.id} carrierName={carrier.name} />
          </Box>
          <Box pr="2x_small">
            <Body
              type="small"
              color="neutral.70"
              weight="medium"
              sx={{ lineHeight: '16px' }}
            >
              {carrier.name}
            </Body>
          </Box>
        </FlexRow>
      </Col>

      <Col flex="0 0 auto">
        <Box pr="2x_small" as="span" sx={{ verticalAlign: 'middle' }}>
          <Body inline as="span" type="small" color="neutral.70">
            <PriceFreezeDate format={'EEEddMM'} date={departureDate} />
          </Body>
        </Box>
      </Col>
    </FlexRow>
  );
}

export function SegmentWithPrice({ segment, type }) {
  const { t } = useTranslation();
  const segmentType =
    type === 'outbound'
      ? t('itinerarydetails.departure')
      : t('itinerarydetails.return');

  const departureDate = segment.sections[0].departureDate;
  return (
    <>
      <SegmentHeader
        carrier={segment.carrier}
        text={segmentType}
        departureDate={departureDate}
      />
      <SegmentDetails segment={segment} />
    </>
  );
}
